/* Returns the timestamp (ms) for midnight today in the user's local timezone. */

export function getLocalMidnight(): number {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return now.getTime();
}
